const appEnv =
    process.env.APP_ENV ||
    (process.env.NODE_ENV === "development" ? "dev" : "pro");

export default {
    appEnv,
    /**
     * @description api请求基础路径
     */
    baseUrl: {
        dev: "http://localhost:5000",
        uat: "https://legacy-uat.brightenseed.cn",
        pro: "https://legacy.brighten-floriplant.cn",
    },
    fileServerUrl: {
        dev: "https://img.brighten-floriplant.cn",
        uat: "https://img.brighten-floriplant.cn",
        pro: "https://img.brighten-floriplant.cn",
    },
    downLoadFileUrl: {
        dev: "http://localhost:5000/storage",
        uat: "https://legacy-uat.brightenseed.cn/storage",
        pro: "https://oss.brighten-floriplant.cn",
    },
    devEnvironment: appEnv === "uat", //测试环境标识
};



// WEBPACK FOOTER //
// ./src/config/index.js